if (!customElements.get('card-media-slider')) {
  customElements.define(
    'card-media-slider',
    class CardMediaSlider extends HTMLElement {
      connectedCallback() {
        if (this.track) return;
        this.track = this.querySelector('.card-media-slider__track');
        this.slides = Array.from(this.track.children);
        this.dots = Array.from(this.querySelectorAll('.card-media-slider__dot'));
        this.index = 0;

        this.track.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
        // Offscreen slides in a horizontal scroller only start loading once
        // they scroll into view; fetch the next one as soon as the shopper
        // shows intent, so a swipe doesn't reveal a blank frame.
        const warm = () => this.preload(this.index + 1);
        this.addEventListener('pointerenter', warm, { once: true });
        this.addEventListener('touchstart', warm, { once: true, passive: true });
      }

      onScroll() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const width = this.track.clientWidth;
          if (!width) return;
          const index = Math.round(this.track.scrollLeft / width);
          if (index !== this.index) this.update(index);
        });
      }

      update(index) {
        this.index = index;
        this.dots.forEach((dot, i) => {
          dot.dataset.distance = Math.min(Math.abs(i - index), 3);
        });
        this.preload(index + 1);
      }

      preload(index) {
        const img = this.slides[index]?.querySelector('img[loading="lazy"]');
        if (img) img.loading = 'eager';
      }
    }
  );
}
